import {
  Box,
  Button,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { MainCard } from "../../../components/surface/MainCard";
import { SectionBox } from "../../../components/surface/SectionBox";
import { useFormik } from "formik";
import { apiStore } from "../../../api/ApiFactory";
import * as Yup from "yup";
import { useParams, useNavigate } from "react-router-dom";
import { IPartOrder } from "../../../models/PartOrder";
import ConfirmationModal from "../ConfirmationModal";
import { useNotification } from "../../../store/context/NotificationContext";
import {getLookupsDetails} from "../../../store/slices/BoatOrdering/BoatOrderingSelector";
import { useSelector } from "react-redux";

const SubmitMotorOrder = () => {

  const { Toast } = useNotification();
  const navigate = useNavigate();

  const [dealerOptions, setDealerOptions] = useState<any>([]);
  const [locationOptions, setLocationOptions] = useState<any>([]);
  const [termOptions, setTermOptions] = useState<any>([]);
  const [freightOptions, setFreightOptions] = useState([]);
  const [openModal, setOpenModal] = useState<any>(false);
  let { id } = useParams();

  const lookups = useSelector(getLookupsDetails);

  const initialValues: IPartOrder = {
    poNum: "",
    custId: "",
    term: "",
    shipVia: "",
    partNum: id ?? "",
    dealerId: ""
  }

  /*
  const fetchLoopups = async () => {
    const result = await apiStore.boatOrderingApi.fetchLookupList();
    console.log(result);
    createDealerOptions(result?.dealerList);
    createTermsOptions(result?.financeTermList);
    createFreightOptions(result?.freightMethodList);
  };

  useEffect(() => {
    fetchLoopups();
  }, []);
  */

  useEffect(() => {
    createDealerOptions(lookups?.dealerList);
    createTermsOptions(lookups?.financeTermList);
    createFreightOptions(lookups?.freightMethodList);

  }, [lookups]);

  const FormValidationSchema = Yup.object({
    dealerId: Yup.number().nullable().required("Dealer is required."),
    custId: Yup.string().required("Location is required."),
    term: Yup.string().required("Term Option is required."),
    shipVia: Yup.string().required("Freight Option is required.")
  });

  const formik = useFormik({
    enableReinitialize: true,
    validationSchema: FormValidationSchema,
    initialValues: initialValues,
    onSubmit: (values) => {
      console.log(values);
      setOpenModal(values);
    },
  });

  const createDealerOptions = (dealerList: any) => {
    let list: any = [];
    dealerList.forEach(({ id, name, ...rest }: any) => {
      const obj = { key: id, value: name, ...rest };
      list.push(obj);
    });
    setDealerOptions(list);
  };

  const createLocationOption = (dealerId: any) => {
    let list: any;
    dealerOptions.forEach((dealer: any) => {
      if (dealerId == dealer.key) {
        list = [...dealer?.locations];
      }
    });
    //console.log(list);
    setLocationOptions(list);
  };

  const createTermsOptions = (options: any) => {
    let list: any = [];
    options.forEach(({ key, displayName }: any) => {
      const obj = { key: key, value: displayName };
      list.push(obj);
    });
    console.log(list);
    setTermOptions(list);
  };

  const createFreightOptions = (options: any) => {
    let list: any = [];
    options.forEach(({ key, displayName }: any) => {
      const obj = { key: key, value: displayName };
      list.push(obj);
    });
    console.log(list);
    setFreightOptions(list);
  };

  const saveData = () => {
    apiStore.boatOrderingApi.createPartOrder(openModal)
      .then((response) => {
        Toast.success({title: "Order created successfully."});
        navigate("/boat");
      })
      .catch((error) => {
        Toast.error({
          title: "Network error processing request."
        });
      })
      .finally(() => {
        formik.setSubmitting(false);
      })
  }

  return (
    <>
      <ConfirmationModal
        open={openModal}
        handleClickYes={() => {
          saveData();
          setOpenModal(false);
        }}
        handleClickCancel={() => {
          formik.setSubmitting(false);
          setOpenModal(false)
        }}
        title="Confirmation"
        description="Please acknowledge that this is a firm order."
      />

      <form onSubmit={formik.handleSubmit}>
        <MainCard title="GENERAL INFORMATION">
          <SectionBox>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={6} xl={4}>
                <InputLabel>Dealer *</InputLabel>
                <Select
                  size="small"
                  fullWidth
                  displayEmpty
                  id="dealerId"
                  name="dealerId"
                  onBlur={formik.handleBlur}
                  error={Boolean(formik.touched.dealerId && formik.errors.dealerId)}
                  onChange={(e) => {
                    formik.handleChange(e);
                    createLocationOption(e.target.value);
                  }}
                  value={formik.values.dealerId}
                >
                  {dealerOptions?.length > 0 &&
                    dealerOptions.map(({ key, value }: any) => {
                      return (
                        <MenuItem key={key} value={key}>
                          {value}
                        </MenuItem>
                      );
                    })}
                </Select>
                {formik.touched.dealerId && formik.errors.dealerId && (
                  <FormHelperText error id="email-helper">
                    {formik.errors.dealerId}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} md={12} lg={6} xl={4}>
                <InputLabel>Ship to Location *</InputLabel>
                <Select
                  size="small"
                  fullWidth
                  displayEmpty
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  name="custId"
                  id="custId"
                  error={Boolean(
                    formik.touched.custId && formik.errors.custId
                  )}
                  value={formik.values?.custId ? formik.values?.custId : ""}
                >
                  {locationOptions &&
                    locationOptions.map(({ customerID, name }: any) => {
                      return (
                        <MenuItem key={customerID} value={customerID}>
                          {name}
                        </MenuItem>
                      );
                    })}
                </Select>
                {formik.touched.custId && formik.errors.custId && (
                  <FormHelperText error id="email-helper">
                    {formik.errors.custId}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
          </SectionBox>
        </MainCard>
        <Box mt={2}>
          <MainCard title="FINANCE DETAILS">
            <SectionBox>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={6} xl={4}>
                  <InputLabel>Term Options *</InputLabel>
                  <Select
                    size="small"
                    fullWidth
                    displayEmpty
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values?.term? formik?.values.term : "" }
                    name="term"
                    id="term"
                    error={Boolean(
                      formik.touched.term && formik.errors.term
                    )}
                  >
                    {termOptions &&
                      termOptions.map(({ key, value }: any) => {
                        return (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.touched.term && formik.errors.term && (
                    <FormHelperText error id="email-helper">
                      {formik.errors.term}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={12} lg={6} xl={4}>
                  <InputLabel>Select Freight *</InputLabel>
                  <Select
                    size="small"
                    fullWidth
                    displayEmpty
                    name="shipVia"
                    id="shipVia"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={ formik.values?.shipVia ? formik.values?.shipVia: "" }
                    error={Boolean(formik.touched.shipVia && formik.errors.shipVia )}
                  >
                    {freightOptions &&
                      freightOptions.map(({ key, value }: any) => {
                        return (
                          <MenuItem key={key} value={key}>
                            {value}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.touched.shipVia && formik.errors.shipVia && (
                      <FormHelperText error id="email-helper">
                        {formik.errors.shipVia}
                      </FormHelperText>
                    )}
                </Grid>
              </Grid>
            </SectionBox>
          </MainCard>
        </Box>
        <Box mt={2}>
          <MainCard title="CUSTOMER DETAILS">
            <SectionBox>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={6} xl={4}>
                  <InputLabel>Customer PO </InputLabel>
                  <TextField
                    id="poNum"
                    name="poNum"
                    fullWidth
                    size="small"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={
                      formik.values?.poNum ? formik.values?.poNum : ""
                    }
                  />
                </Grid>
              </Grid>
            </SectionBox>
          </MainCard>
        </Box>
        <Stack justifyContent="flex-end" direction="row" mt={2}>
          <Button 
            variant="contained" 
            type="submit"
            disabled={formik.isSubmitting}
          >
            Submit
          </Button>
        </Stack>
      </form>
    </>
  );
};

export default SubmitMotorOrder;
